/**
 * Cookie consent banner customization (works with the "Consent & Privacy"
 * block in app.css).
 *
 * Shopify's native banner is enabled for every region in Admin, so it is the
 * only consent banner on the site -- banner render, blocking, and persistence
 * are entirely Shopify's platform responsibility, untouched by any theme code.
 *
 * This file only relocates "Manage preferences" to sit right after the privacy
 * policy link in the banner body, styled as a link.
 */
(function () {
  'use strict';

  var BANNER_SELECTOR = '#shopify-pc__banner, .shopify-pc__banner';
  var cachedBanner = null;
  var bannerSeen = false;
  var warnedNoBanner = false;
  var warnedNoBtn = false;

  // querySelector that also descends into (open) shadow roots.
  function deepQuery(selector, root) {
    var el = root.querySelector(selector);
    if (el) return el;
    var nodes = root.querySelectorAll('*');
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].shadowRoot) {
        var found = deepQuery(selector, nodes[i].shadowRoot);
        if (found) return found;
      }
    }
    return null;
  }

  function getBanner() {
    if (cachedBanner && cachedBanner.isConnected) return cachedBanner;
    cachedBanner = deepQuery(BANNER_SELECTOR, document);
    return cachedBanner;
  }

  // Find the privacy policy link within the banner body. Prefer a link whose
  // href mentions "privacy", then any policy link, then the last link present.
  function findPolicyLink(banner) {
    var links = banner.querySelectorAll('a');
    var lastPolicy = null;
    for (var i = 0; i < links.length; i++) {
      var href = (links[i].getAttribute('href') || '').toLowerCase();
      if (href.indexOf('privacy') !== -1) return links[i];
      if (href.indexOf('/policies/') !== -1) lastPolicy = links[i];
    }
    return lastPolicy || (links.length ? links[links.length - 1] : null);
  }

  function stopObserving() {
    if (!observer) return;
    observer.disconnect();
    observer = null;
  }

  // Append the button to the END of the body copy (the paragraph that contains
  // the privacy policy link) so it follows the whole sentence. Idempotent: a
  // no-op once it's already the last element.
  function relocateManagePrefs() {
    var banner = getBanner();
    if (!banner) {
      // Seen-then-gone means the visitor decided and Shopify removed the
      // banner. Stop observing: otherwise every later DOM mutation re-walks
      // the whole document (shadow roots included) for a banner that won't
      // come back this page view. The 20s poll below still covers a banner
      // Shopify merely re-renders.
      if (bannerSeen) stopObserving();
      return;
    }
    bannerSeen = true;

    var btn = banner.querySelector('.shopify-pc__banner__btn-manage-prefs');
    if (!btn) {
      if (!warnedNoBtn) {
        warnedNoBtn = true;
        console.warn('[consent] Banner found but no .shopify-pc__banner__btn-manage-prefs. Buttons present:',
          [].map.call(banner.querySelectorAll('button'), function (b) { return b.className; }));
      }
      return;
    }

    var link = findPolicyLink(banner);
    var body = (link && link.parentNode) ||
      banner.querySelector('.shopify-pc__banner__body') ||
      banner.querySelector('.shopify-pc__banner__wrapper') ||
      banner;

    if (body.lastElementChild === btn) return; // already in place

    body.appendChild(btn);
    btn.classList.add('manage-prefs-inline');

    // Reword to "To manage your preferences click here", with only "click here"
    // as the link. The aria-label starts with the visible text so voice-control
    // users can say "click here", and still names the action for screen readers.
    btn.textContent = 'click here';
    btn.setAttribute('aria-label', 'click here to manage cookie preferences');
    body.insertBefore(document.createTextNode(' - To manage your preferences'), btn);

    // The theme stylesheet can't reach inside a shadow root, so style inline there.
    if (banner.getRootNode() !== document) {
      btn.style.cssText += ';display:inline;margin:0 0 0 .4em;padding:0;border:0;' +
        'background:none;font:inherit;color:inherit;text-decoration:underline;cursor:pointer;';
    }
  }

  // The banner is injected (and may be re-rendered) by Shopify asynchronously,
  // so watch the DOM and also poll as a safety net.
  relocateManagePrefs();

  var observer = null;
  if (typeof MutationObserver === 'function') {
    observer = new MutationObserver(relocateManagePrefs);
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  var tries = 0;
  var poll = setInterval(function () {
    relocateManagePrefs();
    if (++tries >= 40) { // ~20s
      clearInterval(poll);
      if (!cachedBanner) stopObserving();
      if (!bannerSeen) {
        if (!warnedNoBanner) {
          warnedNoBanner = true;
          console.warn('[consent] No consent banner (' + BANNER_SELECTOR +
            ') found in light or shadow DOM after 20s; "Manage preferences" not relocated.');
        }
      }
    }
  }, 500);
})();
